/**
 * Shared structural shell for every Auth screen (login, MFA, tenant select,
 * passkey enrollment, session expired). This is the single source of truth
 * for the two-column composition, brand panel, and content column — screen
 * components only ever control their own content (via <AuthCard>), never
 * shell geometry. Breakpoints and dimensions here mirror the validated
 * prototype's styles/auth.css (see analysis/AUTH_PROTOTYPE_VS_REACT_AUDIT.md
 * §E) pending a Figma pixel-parity pass (still unauthorized as of writing —
 * see analysis/AUTH_FULL_RESPONSIVE_VISUAL_AUDIT.md).
 */

export function AuthShell({ children }: { children: React.ReactNode }) {
  return <div className="auth-shell">{children}</div>;
}

export function AuthBrandPanel() {
  return (
    <aside className="brand-panel" aria-hidden="true">
      <span className="bp-glow1" />
      <span className="bp-glow2" />
      <div className="bp-content">
        <span className="bp-eyebrow">Provider-neutral</span>
        <span className="bp-tagline">Digital asset operations, governed end to end.</span>
      </div>
    </aside>
  );
}

export function AuthContent({ children }: { children: React.ReactNode }) {
  return (
    <div className="auth-main">
      <svg className="auth-pattern" aria-hidden="true">
        <defs>
          <pattern id="auth-pattern" width="28" height="28" patternUnits="userSpaceOnUse">
            <circle cx="14" cy="14" r="1" fill="var(--ads-primary)" />
          </pattern>
        </defs>
        <rect width="100%" height="100%" fill="url(#auth-pattern)" />
      </svg>
      {children}
    </div>
  );
}
